import { Injectable } from '@angular/core';
import { PricingRepository } from './pricing.repository';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GeneralResponse } from 'src/app/comercial/reffer/domain/reffer-response';
// import { Obtener_DplaMax_PlantillaRequest, TAR_ListarPlantillasRequest, TAR_MantenimientoPlantillasRequest } from '../componentes/plantilla/domain/plantilla.request';
// import { Obtener_DplaMax_PlantillaReponse, TAR_ListarPlantillasResponse } from '../componentes/plantilla/domain/plantilla.response';
// import { ListarTarifaRequest, ListaTarifaRequest, MantenimientoTarifaRequest } from '../componentes/tarifa/domain/tarifa.request';
// import { ListarTarifaResponse, ListaTarifaResponse } from '../componentes/tarifa/domain/tarifa.response';
import { GeneralTransaccionResponse } from 'src/app/operacion/tarja/domain/tarja.response';
// import { ActualizarEstContratoRequest, ActualizarTarifarioRequest, ListarContratoyTarifaRequest, ListarTariProfitPromRequest, ListarTariSegmentadaRequest, SegmentarTarifaRequest, TransaccionProfitPromRequest, ValidarContratoRequest } from '../componentes/segmentacion-de-tarifa/domain/segmentacion-de-tarifa.request';
// import { ActualizarEstContratoResponse, ActualizarTarifarioResponse, ListarContratoyTarifaDetalleResponse, ListarContratoyTarifaResponse, ListarTariProfitPromResponse, ListarTariSegmentadaResponse, SegmentarTarifaResponse, TransaccionProfitPromResponse, ValidarContratoResponse } from '../componentes/segmentacion-de-tarifa/domain/segmentacion-de-tarifa.response';
import { GuardarColumnasParaEjecutivoPlantillaRequest, ListarColumnasParaEjecutivoPlantillaRequest, Obtener_DplaMax_PlantillaRequest, TAR_ListarPlantillasRequest, TAR_MantenimientoPlantillasRequest } from '../plantilla/domain/plantilla.request';
import { ListarColumnasParaEjecutivoPlantillaResponse, Obtener_DplaMax_PlantillaReponse, TAR_ListarPlantillasResponse } from '../plantilla/domain/plantilla.response';
import { anularTarifaRequest, COM_TransaccionProfitMinimoRequest, ListaTarifaRequest, MantenimientoTarifaRequest, SLI_ActivarDesactivarTarifaRequest, SLI_BuscarTarifaEspecialRequest, SLI_CargarTarifaRequest, SLI_ListarTarifaRequest, SLI_ListarTarifaTipoServicioRequest, SLI_MantenimientoTarifaRequest, SLI_TransaccionProfitMinimoRequest, SLI_TransaccionTarifaEspecialRequest } from '../tarifa/domain/tarifa.request';
import { ListaTarifaResponse, ObtenerParametrosResponse, SLI_BuscarTarifaEspecialResponse, SLI_TransaccionTarifaEspecialResponse } from '../tarifa/domain/tarifa.response';
import { ActualizarEstContratoRequest, ActualizarTarifarioRequest, ListarContratoyTarifaRequest, ListarTariProfitPromRequest, ListarTariSegmentadaRequest, SegmentarTarifaRequest, TransaccionProfitPromRequest, ValidarContratoRequest } from '../segmentacion-tarifa/domain/segmentacion-tarifa.request';
import { ActualizarEstContratoResponse, ActualizarTarifarioResponse, ListarContratoyTarifaDetalleResponse, ListarContratoyTarifaResponse, ListarTariProfitPromResponse, ListarTariSegmentadaResponse, SegmentarTarifaResponse, TransaccionProfitPromResponse, ValidarContratoResponse } from '../segmentacion-tarifa/domain/segmentacion-tarifa.response';
import { generalTransaccionResponse } from 'src/app/shared/domain/shared.request';
import { ObtenerParametrosRequest, SLI_CambiarEstadoProfitMinimoRequest, SLI_CargarProfitMinimoRequest, SLI_ListarProfitMinimoRequest, SLI_ObtenerProfitMinimoRequest } from '../../mantenimiento/profit-minimo/domain/mantenimiento-supply.request';

@Injectable({
  providedIn: 'root'
})
export class PricingService extends PricingRepository {

  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }
  //#region PLANTILLLA
  TAR_ListarPlantillas(fd: TAR_ListarPlantillasRequest): Observable<TAR_ListarPlantillasResponse> {
    return this.http.post<TAR_ListarPlantillasResponse>(`${environment.PATH_API}/pricing/TAR_ListarPlantillas`, fd);
  }
  TAR_MantenimientoPlantillas(fd: TAR_MantenimientoPlantillasRequest): Observable<GeneralResponse> {
    return this.http.post<GeneralResponse>(`${environment.PATH_API}/pricing/TAR_MantenimientoPlantillas`, fd);
  }
  override GuardarColumnasParaEjecutivoPlantilla(fd: GuardarColumnasParaEjecutivoPlantillaRequest): Observable<GeneralResponse> {
    return this.http.post<GeneralResponse>(`${environment.PATH_API}/pricing/GuardarColumnasParaEjecutivoPlantilla`, fd);
  }
  override ListarColumnasParaEjecutivoPlantilla(fd: ListarColumnasParaEjecutivoPlantillaRequest): Observable<ListarColumnasParaEjecutivoPlantillaResponse> {
    return this.http.post<ListarColumnasParaEjecutivoPlantillaResponse>(`${environment.PATH_API}/pricing/ListarColumnasParaEjecutivoPlantilla`, fd);
  }
  Obtener_DplaMax_Plantilla(fd: Obtener_DplaMax_PlantillaRequest): Observable<Obtener_DplaMax_PlantillaReponse> {
    return this.http.post<Obtener_DplaMax_PlantillaReponse>(`${environment.PATH_API}/pricing/Obtener_DplaMax_Plantilla`, fd);
  }
  //#endregion 

  override ListaTarifa(request: ListaTarifaRequest): Observable<ListaTarifaResponse> {
    return this.http.post<ListaTarifaResponse>(`${environment.PATH_API}/supply/ListaTarifa`, request)
  }
  AnularTarifa(fd: anularTarifaRequest): Observable<GeneralResponse> {
    return this.http.post<GeneralResponse>(`${environment.PATH_API}/supply/AnularTarifa`, fd);
  }
  override MantenimientoTarifa(request: MantenimientoTarifaRequest): Observable<GeneralTransaccionResponse> {
    return this.http.post<GeneralTransaccionResponse>(`${environment.PATH_API}/supply/ManteTari`, request)
  }

  override ListaContratoyTarifa(request: ListarContratoyTarifaRequest): Observable<ListarContratoyTarifaResponse> {
    return this.http.post<ListarContratoyTarifaResponse>(`${environment.PATH_API}/segmentaciontarifas/ListarContratosyTarifas`, request)
  }

  override ListaContratoyTarifaDetalle(request: ListarContratoyTarifaRequest): Observable<ListarContratoyTarifaDetalleResponse> {
    return this.http.post<ListarContratoyTarifaDetalleResponse>(`${environment.PATH_API}/segmentaciontarifas/ListarContratosyTarifas`, request)
  }
  override TransPofitProm(request: TransaccionProfitPromRequest): Observable<TransaccionProfitPromResponse> {
    return this.http.post<TransaccionProfitPromResponse>(`${environment.PATH_API}/segmentaciontarifas/TransaccionProfitProm`, request)
  }
  override ListarTariProfitProm(request: ListarTariProfitPromRequest): Observable<ListarTariProfitPromResponse> {
    return this.http.post<ListarTariProfitPromResponse>(`${environment.PATH_API}/segmentaciontarifas/ListarTarifarioProfitProm`, request)
  }
  override SegmentarTarifa(request: SegmentarTarifaRequest): Observable<SegmentarTarifaResponse> {
    return this.http.post<SegmentarTarifaResponse>(`${environment.PATH_API}/segmentaciontarifas/SegmentacionTarifa`, request)
  }
  override ListarTarifaSeg(request: ListarTariSegmentadaRequest): Observable<ListarTariSegmentadaResponse> {
    return this.http.post<ListarTariSegmentadaResponse>(`${environment.PATH_API}/segmentaciontarifas/ListarTarifaSegmentada`, request)
  }
  override ValidarContrato(request: ValidarContratoRequest): Observable<ValidarContratoResponse> {
    return this.http.post<ValidarContratoResponse>(`${environment.PATH_API}/segmentaciontarifas/ValidarContrato`, request)
  }
  override ActualizarTarifario(request: ActualizarTarifarioRequest): Observable<ActualizarTarifarioResponse> {
    return this.http.post<ActualizarTarifarioResponse>(`${environment.PATH_API}/segmentaciontarifas/ActtualizarTarifario`, request)
  }
  override ActualizarEstContrato(request: ActualizarEstContratoRequest): Observable<ActualizarEstContratoResponse> {
    return this.http.post<ActualizarEstContratoResponse>(`${environment.PATH_API}/segmentaciontarifas/ActtualizarEstadoContrato`, request)
  }
  //#region SLI TARIFA
  override ListarTarifaMatriz(): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getMatriz`, null)
  }
  override SLI_ListarTarifa(request: SLI_ListarTarifaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getTarifa`, request)
  }
  override SLI_CargarTarifa(request: SLI_CargarTarifaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/changeTarifa`, request)
  }
  override SLI_MantenimientoTarifa(request: SLI_MantenimientoTarifaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/setTarifa`, request)
  }
  override SLI_ActivarDesactivarTarifa(request: SLI_ActivarDesactivarTarifaRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/disabledTarifa`, request)
  }
  override SLI_ListarTarifasExpeciales(request: SLI_BuscarTarifaEspecialRequest): Observable<SLI_BuscarTarifaEspecialResponse> {
    return this.http.post<SLI_BuscarTarifaEspecialResponse>(`${environment.PATH_API}/supply/getTarifasEspeciales`, request)
  }
  override SLI_TransaccionTarifaEspecial(request: SLI_TransaccionTarifaEspecialRequest): Observable<SLI_TransaccionTarifaEspecialResponse> {
    return this.http.post<SLI_TransaccionTarifaEspecialResponse>(`${environment.PATH_API}/supply/tnsTarifasEspeciales`, request)
  }
  override ListarTarifaMatrizTarifario(): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getMatrizTarifario`, null)
  }
  override SLI_ListarTarifaTipoServicio(request: SLI_ListarTarifaTipoServicioRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getTariffByServiceType`, request)

  }
  override SLI_TransaccionProfitMinimo(request: COM_TransaccionProfitMinimoRequest): Observable<generalTransaccionResponse> {
    return this.http.post<any>(`${environment.PATH_API}/supply/setProfitMinimo`, request)
  }
  override SLI_ListarProfitMinimo(request: SLI_ListarProfitMinimoRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/listProfitMinimo`, request)
  }
  override SLI_ObtenerProfitMinimo(request: SLI_ObtenerProfitMinimoRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/getProfitMinimoByServicio`, request)
  }
  override SLI_CargarProfitMinimo(request: SLI_CargarProfitMinimoRequest): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/supply/loadProfitMinimo`, request)
  }
  override SLI_CambiarEstadoProfitMinimo(request: SLI_CambiarEstadoProfitMinimoRequest): Observable<generalTransaccionResponse> {
    return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/supply/changeStatusProfitMinimo`, request)
  }
  //#endregion

  override ListarServicios(): Observable<any> {
    return this.http.post<any>(`${environment.PATH_API}/parametros/getServicios`, null)
  }

  override ObtenerParametros(request: ObtenerParametrosRequest): Observable<ObtenerParametrosResponse> {
    return this.http.post<any>(`${environment.PATH_API}/parametros/getParameters`, request)
  }
}
